import {Injectable} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class GetFormsReportService {

  constructor(private fb: FormBuilder) {}

  getFilterPilotPlayers(): FormGroup {
    return this.fb.group({
      clientName: [],
      siteName: [],
      countryCode: this.fb.group({code: [null], name: [null]}),
      serviceID: this.fb.group({id: [null], name: [null]}),
      productID: this.fb.group({id: [null], name: [null]}),
      deliveryDate: [],
      numberOfDays: [],
      salesName: [],
      deviceID: [],
      playerName: [],
      updated: [],

    });
  }
  getPlayersReportWithRangeDate(): FormGroup {
    return this.fb.group({
      startDate:  [null, Validators.required],
      endDate:  [null, Validators.required]
    });
  }
  getPlayersReportNewChurnWithRangeDate(): FormGroup {
    return this.fb.group({
      office: this.fb.group({id: [null], name: [null]}),
      startDate:  [null],
      endDate:  [null],
    });
  }
  getFilterSupport(): FormGroup {
    return this.fb.group({
      defaultValue: [],
    });
  }
  getFilterPilotProlongation(): FormGroup {
    return this.fb.group({
      comment: [],
    });
  }
}

